export default class SistemaService {
    constructor(http) {
        this.http = http;
    }

    version() {
        return this.http.get("/system/version").then((res) => (res.status == 200 ? res.data : null));
    }
}
